import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";
import { Check, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GroceryStudentStatsPage() {
  const { user } = useAuth();
  const [stats, setStats] = useState([]);
  const [students, setStudents] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState("Term 1");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());

  useEffect(() => {
    fetchStats();
    fetchStudents();
    fetchSubmissions();
    // eslint-disable-next-line
  }, [selectedTerm, selectedYear]);

  const fetchStats = async () => {
    const res = await axios.get(`${API}/groceries/stats`, { params: { term: selectedTerm, year: selectedYear } });
    setStats(res.data);
  };
  const fetchStudents = async () => {
    const res = await axios.get(`${API}/students`);
    setStudents(res.data);
  };
  const fetchSubmissions = async () => {
    const res = await axios.get(`${API}/groceries/submissions`, { params: { term: selectedTerm, year: selectedYear } });
    setSubmissions(res.data);
  };

  // Collapsible state for each class table
  const [tableOpen, setTableOpen] = useState({});
  const toggleTableOpen = (className) => setTableOpen((prev) => ({ ...prev, [className]: !prev[className] }));

  return (
    <div>
      <h1 className="font-heading font-bold text-2xl mb-4">Student Grocery Stats</h1>
      <Accordion type="multiple" className="w-full">
        {Object.entries(stats.reduce((acc, row) => {
          if (!acc[row.class_name]) acc[row.class_name] = [];
          acc[row.class_name].push(row);
          return acc;
        }, {})).map(([className, classStats]) => {
          const classStudents = students.filter(s => s.class_name === className);
          const classItems = classStats;
          const studentItemMap = {};
          classStudents.forEach(stu => {
            studentItemMap[stu.id] = {};
            classItems.forEach(item => {
              const brought = submissions.some(sub => sub.student_id === stu.id && sub.grocery_item_id === item.item_id);
              studentItemMap[stu.id][item.item_id] = brought;
            });
          });
          return (
            <AccordionItem key={className} value={className}>
              <AccordionTrigger>{className}</AccordionTrigger>
              <AccordionContent>
                <div className="mb-2">
                  <button
                    className="text-sm text-blue-600 hover:underline mb-2"
                    onClick={() => toggleTableOpen(className)}
                    type="button"
                  >
                    {tableOpen[className] !== false ? 'Hide Table ▲' : 'Show Table ▼'}
                  </button>
                  {tableOpen[className] !== false && (
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Student</TableHead>
                          {classItems.map(item => (
                            <TableHead key={item.item_id} className="text-center">{item.item_name}</TableHead>
                          ))}
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {classStudents.map(stu => (
                          <TableRow key={stu.id}>
                            <TableCell>{stu.first_name} {stu.last_name}</TableCell>
                            {classItems.map(item => (
                              <TableCell key={item.item_id} className="text-center">
                                {studentItemMap[stu.id][item.item_id] ? <Check className="text-green-500 mx-auto" size={18} /> : <X className="text-red-500 mx-auto" size={18} />}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )}
                </div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}
